import React, { memo } from 'react'
import {
    CartesianGrid,
    AreaChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
    Area,
} from 'recharts'
import { APP_COLORS, EMBED_ANALYTICS_COLORS } from '../components'
import { translate } from '../i18n'
import { ScansChartProps } from './ScansChart.types'

// Backend sends day keys as YYYY-MM-DD. Reformat to MM/DD/YY directly from the
// string parts to avoid timezone parsing shifting the date by a day.
const formatDateLabel = (value: string): string => {
    const [year, month, day] = String(value).slice(0, 10).split('-')
    if (!year || !month || !day) {
        return String(value)
    }
    return `${month}/${day}/${year.slice(2)}`
}

function ScansChart({ scans, embedded = false }: ScansChartProps) {
    const lineColor = embedded
        ? EMBED_ANALYTICS_COLORS.data
        : APP_COLORS.chart.one

    const tooltipFormatter = (value: number | string) =>
        [value, translate('projects.analytics.scans') as string] as [
            number | string,
            string
        ]

    return (
        <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
                <AreaChart data={scans}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" tickFormatter={formatDateLabel} />
                    <YAxis allowDecimals={false} width={35} />
                    <Tooltip
                        formatter={tooltipFormatter}
                        labelFormatter={formatDateLabel}
                    />
                    <Area
                        type="monotone"
                        dataKey="count"
                        stroke={lineColor}
                        fill={lineColor}
                        fillOpacity={0.15}
                        dot={false}
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    )
}

export default memo(ScansChart)
